'use client';

interface PlayerIconProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: string;
  onClick?: () => void;
}

function PersonIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
}

export const getTextColor = (bgColor: string) => {
  if (!bgColor) return 'text-gray-600 dark:text-gray-300';

  // Light colors that need dark text
  if (
    bgColor.includes('white') ||
    bgColor.includes('yellow') ||
    bgColor.includes('mint') ||
    bgColor.includes('lightblue')
  ) {
    return 'text-black';
  }

  // Dark colors that need light text
  return 'text-white';
};

export default function PlayerIcon({
  size = 'md',
  className = '',
  color,
  onClick,
}: PlayerIconProps) {
  // Size classes
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  };

  const baseClasses = `flex items-center justify-center rounded-full ${sizeClasses[size]} ${className}`;
  const backgroundColor = color || 'bg-gray-200';

  // Determine text color based on background color for visibility
  const textColor = getTextColor(backgroundColor);

  return (
    <div
      className={`${baseClasses} ${backgroundColor} ${textColor} ${onClick ? 'cursor-pointer transition-opacity hover:opacity-80' : ''}`}
      onClick={onClick}
    >
      <PersonIcon className="h-2/3 w-2/3" />
    </div>
  );
}
